import { render } from "./ArchiveModal.vue?vue&type=template&id=96363a64"
import script from "./ArchiveModal.vue?vue&type=script&lang=js"
export * from "./ArchiveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__